import { AppEnum, formatName, MatchingEnums} from "@/Shared";

import { MatchingModel } from '../MatchingModel';
import { MatchingFormValues } from "../MatchingFormValidation";


export class MatchingFormViewModel {
    
    public constructor(private _viewEnums : MatchingEnums, private _enrichedMatching?: MatchingModel) {}

    getError = (error?: string) => error || "Une erreur s'est produite";

    getSuccess = () => this._enrichedMatching ? "Besoin mise à jour avec succés" : "Besoin créé avec succés";

    get formValues() {
        return {
            status: this._enrichedMatching?.status
        } as MatchingFormValues
    }

    get id() {
        return this._enrichedMatching?.id;
    }

    get statusOptions(): AppEnum[] { return this._viewEnums.MatchingStatusEnum;}

    get title() {
        return this._enrichedMatching 
        ? "Besoin de " + formatName(this._enrichedMatching?.need?.contact?.person) 
        : "Création de rapprochement";
    }
}